import { render, staticRenderFns } from "./VerificationFormProductRisk.vue?vue&type=template&id=63550a06&"
import script from "./VerificationFormProductRisk.vue?vue&type=script&lang=js&"
export * from "./VerificationFormProductRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports